export const checkInOfferRequestSource = {
    OFFER_CODE: 'OFFER_CODE',
    LICENSE_PLATE: 'LICENSE_PLATE'
};
